export class PatientReassignmentError extends Error {
	/**
	 * @param {string} message
	 * @param {number | null} patientId
	 */
	constructor(message, patientId = null) {
		super(message)
		this.patientId = patientId
	}
}

export class NoChairFoundForPatientError extends PatientReassignmentError {}

export class NoNurseFoundForPatientError extends PatientReassignmentError {}

/**
 * @extends {PatientReassignmentError}
 *
 * No patient matching the given id was found in the schedule data structure
 */
export class PatientNotFoundError extends PatientReassignmentError {
	/**
	 * @param {number} patientId
	 * @param {string} dataStructureName
	 * @param {Any} dataStructure
	 */
	constructor(patientId, dataStructureName, dataStructure) {
		super(`No patient found with id ${patientId} in ${dataStructureName}`, patientId)
		this.dataStructureName = dataStructureName
		this.dataStructure = dataStructure
	}
}

/**
 * @extends {PatientReassignmentError}
 *
 * No nurse matching the given id was found in the schedule data structure
 */
export class NurseNotFoundError extends PatientReassignmentError {
	/**
	 * @param {number} nurseId
	 * @param {string} dataStructureName
	 * @param {Any} dataStructure
	 */
	constructor(nurseId, dataStructureName, dataStructure) {
		super(`No nurse found with id ${nurseId} in ${dataStructureName}`, nurseId)
		this.dataStructureName = dataStructureName
		this.dataStructure = dataStructure
	}
}

/**
 * @extends {PatientReassignmentError}

 *
 * No chair matching the given id was found in the schedule data structure
 */
export class ChairNotFoundError extends PatientReassignmentError {
	/**
	 * @param {number} chairId
	 * @param {string} dataStructureName
	 * @param {Any} dataStructure
	 */
	constructor(chairId, dataStructureName, dataStructure) {
		super(`No chair found with id ${chairId} in ${dataStructureName}`)
		this.chairId = chairId
		this.dataStructureName = dataStructureName
		this.dataStructure = dataStructure
	}
}
